export const HOURS_1 = '9:30 am - 2 pm, 2:30 pm - 6 pm';
export const HOURS_2 = '10:00 am – 2:30 pm';

export const BRANCH_INIT = {
    name: '',
    phone: '',
    email: '',
    businessHours: [{
        dayRange: 'Lunes a Viernes',
        hours: HOURS_1,
        rangeError: false,
        hoursError: false
    }, {
        dayRange: 'Sábado',
        hours: HOURS_2,
        rangeError: false,
        hoursError: false
    }],
    address: '',
    postalCode: '',
    colony: '',
    city: '',
    state: '',
    links: {
        whatsapp: {
            number: '',
            message: 'Buen día, me gustaría obtener información'
        },
        facebook: {
            url: ''
        },
        google_maps: {
            placeId: '',
            location: {
                lat: '',
                lng: ''
            }
        }
    }
};

export const BRANCH_EDIT = {
    ...BRANCH_INIT,
    _id: ''
};

export const BRANCH_FIELD_ERR = {
    name_err: false,
    phone_err: false,
    email_err: false,
    address_err: false,
    pc_err: false,
    colony_err: false,
    city_err: false,
    state_err: false,
    wsp_number_err: false,
    wsp_message_err: false,
    facebook_url_err: false,
    place_id_err: false
};
